import React from 'react';
import { Table, Button } from 'reactstrap';
import Row from '../Row';
import $ from 'jquery';
import DropZoneTable from './DropZoneTable';
import { connect } from 'react-redux'
import { Flag } from 'flagger/react';
import UpArrow from '@mui/icons-material/KeyboardArrowUp';
import DownArrow from '@mui/icons-material/KeyboardArrowDown';

class DestinationsTable extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentPage: 0,
            numPages: 0,
            pageNumber: 1,
            prevPageLimit: 0,
            pageLimit: 10,
            rowsShown: 9,
            sortConfig: { key: null, direction: 'asc' },
            ...props,
            filters: {
                name: '',
                folder: '',
                destination:'',
                printer_count:''
            },
            showFilters: false
        }

        this.goToNextPage = this.goToNextPage.bind(this)
        this.goToPrevPage = this.goToPrevPage.bind(this)
    }

    componentDidUpdate(prevProps) {
        if (this.props.logs && this.props.logs.length !== prevProps.logs?.length) {
            const noPages = Math.ceil(this.props.logs.length / this.state.pageLimit);
            this.setState({
                numPages: noPages,
                currentPage: 0,
                logs: this.props.logs
            });
        }
    }


    handleFilterChange = (key, value) => {
    this.setState((prevState) => ({
        filters: {
            ...prevState.filters,
            [key]: value
        },
        currentPage: 0 // optional: reset to first page on filter
        }));
    };

    toggleFilters = () => {
        this.setState((prevState) => ({
            showFilters: !prevState.showFilters
        }));
    };
    
    clearAllFilters = () => {
        this.setState({
            filters: {
            name: '',
            folder: '',
            destination: '',
            printer_count: ''
            },
            currentPage: 0 // optional: reset to first page
        });
    };

    goToNextPage() {
        let page = this.state.currentPage + 1
        if (page < this.state.numPages)
            this.setState({
                currentPage: page
            })
    }

    goToPrevPage() {
        let page = this.state.currentPage - 1
        if (page >= 0)
            this.setState({
                currentPage: page
            })
    }

    onSort = (key) => {
        this.setState((prevState) => {
            const direction = prevState.sortConfig.key === key && prevState.sortConfig.direction === 'asc' ? 'desc' : 'asc';

            const logs = prevState.logs ?? this.props.logs;

            const sortedRows = [...logs].sort((a, b) => {
                let aValue = key === 'printer_count' ? a.Printers.length : a[key];
                let bValue = key === 'printer_count' ? b.Printers.length : b[key];

                // Fallback in case of undefined values
                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';

                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();

                if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            return {
                logs: sortedRows,
                sortConfig: { key, direction }
            };
        });
    };

    renderSortableFilterableHeader = (filterKey, onSort, labelKey, labelFallback) => {
      const isSorted = this.state.sortConfig.key === filterKey;
      const sortArrow = isSorted
      ? this.state.sortConfig.direction === 'asc'
        ? <UpArrow />
        : <DownArrow />
      : null;

      const label = this.getLocalizedLabel(labelKey, labelFallback);

      return (
      <th
        key={filterKey}
        className="s-grid-title-cell"
        style={{ cursor: 'pointer' }}
        onClick={() => this.onSort(onSort)}
      >
        <div className="s-grid-title-cell-filter">
          {label} {sortArrow}
        </div>
        <div>
          {this.state.showFilters && (
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder="Start typing to search..."
              value={this.state.filters[filterKey] || ''}
              onMouseDown={(e) => e.stopPropagation()}
              onChange={(e) => this.handleFilterChange(filterKey, e.target.value)}
            />
          )}
        </div>
      </th>
      );
    };

    getLocalizedLabel = (key, fallback) => {
      const labelObj = this.props.userReducer.localisation[key];
      return labelObj?.element_lang || fallback;
    };


    render() {

        let b = true;
        let grid_css
        let id;
        let rows = [];
        let pageignation = <div />;
        let is_checked = false;

        const { localisation } = this.props.userReducer;

        const filtersActive = Object.values(this.state.filters).some(
            val => val.trim() !== ''
        );

        let startItem = (this.state.currentPage * this.state.rowsShown) + this.state.currentPage;
        let endItem = startItem + this.state.rowsShown;

        let logsToRender = (this.state.logs.length ? this.state.logs : this.props.logs).filter(file => {
            const { filters } = this.state;

            const matches = (field, value) =>
                field?.toString().toLowerCase().includes(value.toLowerCase());

            return (
                matches(file.Group, filters.name) &&
                matches(file.Folder, filters.folder) &&
                matches(file.Destination, filters.destination) &&
                matches(file.Printers?.length?.toString(), filters.printer_count)
            );

        });


        if (logsToRender) {
            logsToRender.forEach((row, i) => {
                 if (!this.props.nopages) {
                if (i < startItem)
                    return
                if (i > endItem)
                    return
            }

                if (b)
                    grid_css = "s-grid-row"
                else
                    grid_css = "s-grid-row s-record-alt"
                b = !b

                if (this.props.keyid !== undefined && this.props.keyid === i)
                    grid_css += " dotted-row"

                id = "P" + row.id

                rows.push(
                    <Row
                        printeditorpopover={true}
                        onRowClicked={this.props.onRowClicked}
                        rightAlign={[5]}
                        i={i}
                        viewPortfolio={false}                        
                        checkChange={this.props.checkChange}
                        refresh={this.props.refresh}
                        id={id}
                        fileid={row.id}
                        tr_css={grid_css}
                        filename={row.Group}
                        filetype={row.Folder}
                        user={row.Printers.length}
                        version={row.Destination}
                        file={row}
                        columnConfig={this.props.columnConfig}
                    />
                );
            });
        }


        if (this.props.logs) {
            pageignation = <div>
                <div class="s-array-topbar-right">
                    <label class="s-pager-range">
                        {this.props.logs.length > 1
                            ? localisation['table_header_records']
                            ? this.props.logs.length +
                                ' ' +
                                localisation['table_header_records'].element_lang
                            : this.props.logs.length + ' Records'
                            : localisation['table_header_record']
                            ? this.props.logs.length +
                            ' ' +
                            localisation['table_header_record'].element_lang
                            : this.props.logs.length + ' Record'}
                    </label>
                    <label class="s-pager-range">{this.props.logs.length > 1 ? localisation['table_header_records'] ? this.props.logs.length + ' ' + localisation['table_header_records'].element_lang : '' : localisation['table_header_record'] ? this.props.logs.length + ' ' + localisation['table_header_record'].element_lang : ''}</label>
                    <label class="s-pager-range">|</label>
                    <label class="s-pager-size-label">Page {this.state.currentPage + 1} / {this.state.numPages}</label>
                    <div class="s-pager">
                        <a onClick={this.goToPrevPage} class="s-pager-link s-fonticon-btn s-btn-previous"></a>
                        <a onClick={this.goToNextPage} class="s-pager-link s-fonticon-btn s-btn-next"></a>
                    </div>
                    <a onClick={this.props.refresh} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        style={{ marginLeft: '10px' }}
                        onClick={this.toggleFilters}
                        title={this.state.showFilters ? 'Hide search filters' : 'Show search filters'}
                    >
                        <i className="fa fa-filter" aria-hidden="true"></i>
                        <span style={{ marginLeft: '5px' }}>
                        {this.state.showFilters ? 'Hide search Filters' : 'Show search Filters'}
                        </span>
                    </button>
                    {filtersActive && (
                        <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={this.clearAllFilters}
                            title="Clear all filter fields"
                            style={{ marginLeft: '10px' }}
                        >
                            <i className="fa fa-times" aria-hidden="true" style={{ marginRight: '5px' }}></i>
                            Clear Filters
                        </button>
                    )}
                </div>
            </div>
        }


        return (
            <div class="s-slot-row">
                {pageignation}
                <Table responsive={true} hover={true} className="s-grid-table-head">
                    <tr>
                        {this.props.columnConfig?.actions && (
                            <th className="s-grid-title-cell s-grid-title-cell-small">
                                <div className="s-grid-title-empty"></div>
                            </th>
                        )}
                        {/* filterKey, onSort, labelKey, labelFallback */}
                        {this.renderSortableFilterableHeader('name', 'Group', "table_header_name", "Name")} 
                        {this.renderSortableFilterableHeader('folder', 'Folder', "table_header_folder", "Folder")}
                        {this.renderSortableFilterableHeader('destination', 'Destination', "table_header_destination", "Destination")}
                        {this.renderSortableFilterableHeader('printer_count', 'printer_count', "table_header_printer_count", "Printer Count")}
                    </tr>
                </Table>
                <div class="s-grid-slot-body">
                    <Flag flag="CloudDeployment" entity={{ id: 1 }} case="off">
                        <DropZoneTable refresh={this.props.refresh} rows={rows} dropzone={true} />
                    </Flag>
                    <Flag flag="CloudDeployment" entity={{ id: 1 }} case="on">
                        <DropZoneTable refresh={this.props.refresh} rows={rows} />
                    </Flag>
                </div>
            </div>
        );
    }
}

export default connect(state => state)(DestinationsTable);
